/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * State of an item's rating when a gate runs (DRD 2.1, WEB-PC-047).
 */
enum RatingInputState {
  /** Not fetched yet. The gate holds and decides nothing. */
  PENDING = "PENDING",

  /** Ratings are present, or known to be absent (genuinely unrated). */
  KNOWN = "KNOWN",

  /** The fetch failed or the next program is unknown. The gate fails safe. */
  UNAVAILABLE = "UNAVAILABLE"
}

export { RatingInputState };
